const veterinarians =
{
    title  : 'Vétérinaire',
    titleX : 'Vétérinaires'
};

export default veterinarians ;
